export default {
  scheduleEvent: 'Zaplanuj wydarzenie',
};
